import { StyleSheet } from 'aphrodite';
import { THEME } from '../Theme/theme';

const { colors } = THEME;

export const styleSheet = StyleSheet.create({
	root: {
		alignItems: 'center',
		backgroundColor: colors.primary.main,
		borderRadius: 999,
		color: colors.primary.contrastText,
		display: 'inline-flex',
		fontSize: 9,
		fontWeight: 700,
		height: 14,
		justifyContent: 'center',
		lineHeight: 1,
		minWidth: 14,
		paddingBlock: 0,
		paddingInline: 3,
		pointerEvents: 'none',
		position: 'absolute',
		right: 4,
		top: 6,
	},
});
